<template>
    <vAuthorityComponent v-if="flag" :postList="postList"></vAuthorityComponent>
</template>
<script>
import vAuthorityComponent from '../listComponent/jurisdiction/authorityComponent.vue';
export default {
    name: 'authoritymanagement',
    components: {
        vAuthorityComponent
    },
    data() {
        return {
            flag: false,
            postList: {
                headerTitle: false,
                name: true,
                status: true,
                value: true,
                role: true,
                router: true,
                status: true,
                addBtn: true,
                delateBtn: true,
                searchBtn: true,
                resetBtn: true,
                setBtn: true
            }
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style scoped>
</style>